module.exports = __webpack_public_path__ + "img/removeimages-gray.b201206c.svg";